function MailTo({ mailto }){
    return (
        <div className='mailto'>
            <p>Click the button to open your email in your email app.</p>
            <a className='button white' href={encodeURI(mailto)}>Continue in app</a>
        </div>
    )
}
export default MailTo;